export default __webpack_public_path__ + "static/media/user.8f1ac874.svg";